import React, { useEffect, useState } from 'react';
import { ReactComponent as PlayIcon } from '../assets/icons/play.svg';
import { ReactComponent as PauseIcon } from '../assets/icons/pause.svg';
import './CoverPlayButton.scss';
import CoverArt from './CoverArt';
import { clearDefault } from './TrackArt';

// bare=1: a track with no artwork gets the plain brand gradient — the play
// icon on top is its glyph (the default cover's ♫ would sit beside it). Applies
// to every local art URL, by path or by track id.
const LOCAL_ART = 'http://localhost:3069/album-art';
const bare = (u) => (typeof u === 'string' && u.startsWith(LOCAL_ART) && !/[?&]bare=/.test(u)
    ? `${u}${u.includes('?') ? '&' : '?'}bare=1`
    : u);
const localArtUrl = (fp) =>
    fp && !/^(https?:|online:)/.test(fp)
        ? `${LOCAL_ART}?path=${encodeURIComponent(fp)}&bare=1`
        : null;

// Album-cover thumbnail with a play/pause icon overlaid. The cover is absolutely
// centered on the icon and reserves NO vertical space, so it never changes the
// host row's height. Shared by the Compatibility / Loudness / Cues / Organize
// rows (mirrors the Library rows). Prefers an enriched (Mixpedia) cover, falling
// back to the local album-art endpoint (embedded art or a default gradient).
export default function CoverPlayButton({ filePath, cover, isPlaying, onClick, title, size = 24 }) {
    const src = clearDefault(bare(cover) || localArtUrl(filePath));
    // No artwork (no src, or the art server's 1×1 transparent "clear" image):
    // the icon sits on the grey tile, not on artwork — it takes the text colour.
    const [noArt, setNoArt] = useState(!src);
    useEffect(() => { setNoArt(!src); }, [src]);
    return (
        <span className={`cover-play-slot${noArt ? ' is-bare' : ''}`} style={{ width: size }}>
            {src && (
                <CoverArt
                    className="cover-play-img"
                    src={src}
                    size={size}
                    style={{ width: size, height: size }}
                    onLoad={(e) => setNoArt(e.currentTarget.naturalWidth <= 1)}
                />
            )}
            {isPlaying
                ? <PauseIcon className="cover-play-icon" onClick={onClick} title={title || 'Pause'} />
                : <PlayIcon className="cover-play-icon" onClick={onClick} title={title || 'Play'} />}
        </span>
    );
}
